import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
	let output = [];
	if (data) {
		data.forEach((itm) => {
			let property = {};
			property["data"] = itm;

			output.push(property);
		});
	}

	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		data: {
			alias: "data",
			type: "hidden",
			editable,
		},
	};
}
function barsSet(numberOfBars, numberOfActiveBars) {
	let divsNumber = [];
	for (let i = 1; i <= numberOfBars; i++) {
		if (i <= numberOfActiveBars) {
			divsNumber.push(<div className="bar active"></div>);
		} else {
			divsNumber.push(<div className="bar"></div>);
		}
	}
	return divsNumber;
}

function liElements(data) {
	let output = [];
	if (data.mbInfoList.length > 0) {
		data.mbInfoList.forEach((itm, idx) => {
			let numberOfActiveBars;
			let minimumBarsBytesLimit = 10240;
			let numberOfBars = 8;
			let totalAmountOfMB = itm.totalInBytes;
			let availableAmountOfMB = itm.remainingInBytes;
			if (availableAmountOfMB <= minimumBarsBytesLimit) {
				numberOfActiveBars = 0;
			} else {
				numberOfActiveBars =
					(availableAmountOfMB / totalAmountOfMB) * numberOfBars;
			}
			// Check if it is not an empty object
			if (Object.keys(data.mbInfoList).length !== 0) {
				output.push(
					<li
						key={idx}
						id="statisiticList"
						className={availableAmountOfMB !== 0 ? "remain-data" : ""}>
						<h4>{itm.serviceTitle}</h4>
						<div className="bars">
							{barsSet(numberOfBars, numberOfActiveBars)}
						</div>
						<div className="clear"></div>
						<div>
							<h5>{itm.consumptionInfoMsg}</h5>
							<div className="clear"></div>
						</div>
						<div>
							<h6 className="customFloatLeft">{itm.renewalMsg}</h6>
							<div className="clear"></div>
						</div>
					</li>,
				);
			}
		});
	}
	return output;
}

function cosmokartaLiElements(data) {
	let output = [];
	let listOfDataBuckets = data.allData.listOfDataBuckets;
	let listOfUnlimitedDataPrepaidNinja =
		data.allData.listOfUnlimitedDataPrepaidNinja;

	if (listOfDataBuckets.length > 0) {
		for (let i = 0; i < listOfDataBuckets.length; i++) {
			let unlimitedSpotted = 0;
			if (listOfUnlimitedDataPrepaidNinja.length > 0) {
				for (let j = 0; j < listOfUnlimitedDataPrepaidNinja.length; j++) {
					if (
						listOfDataBuckets[i].name ===
						listOfUnlimitedDataPrepaidNinja[j].bucket
					) {
						unlimitedSpotted = 1;
						break;
					}
				}
			}

			let expirationText = "";
			if (
				listOfDataBuckets[i].type === "CAT1" ||
				listOfDataBuckets[i].type === "CAT2" ||
				listOfDataBuckets[i].type === "CAT3" ||
				listOfDataBuckets[i].type === "CAT7"
			) {
				expirationText = "Διαθέσιμα για VIDEO KAI MUSIC STREAMING έως ";
			} else if (
				listOfDataBuckets[i].type === "SOCIAL1" ||
				listOfDataBuckets[i].type === "SOCIAL2"
			) {
				expirationText = "Διαθέσιμα για SOCIAL MEDIA έως ";
			} else if (
				listOfDataBuckets[i].type === "CHAT1" ||
				listOfDataBuckets[i].type === "CHAT2"
			) {
				expirationText = "Διαθέσιμα για CHATTING έως ";
			} else if (listOfDataBuckets[i].type === "CAT5") {
				expirationText = "Διαθέσιμα για VIDEO KAI MUSIC STREAMING έως ";
			} else if (
				listOfDataBuckets[i].type === "Social_Chat1" ||
				listOfDataBuckets[i].type === "Social_Chat3"
			) {
				expirationText = "Διαθέσιμα για SOCIAL MEDIA έως ";
			} else if (listOfDataBuckets[i].name === "Permanent30") {
				expirationText =
					"Δωρεάν MB για 2 ώρες από το DATAMENOW. Τα ΜΒ του πακέτου λήγουν αυτόματα στις ";
			} else if (listOfDataBuckets[i].name === "SpecificOffers1") {
				expirationText = "AΠO TO ΠΑΚΕΤΟ 10GB ΔΩΡΕΑΝ ΓΙΑ 7 ΗΜΕΡΕΣ ΕΩΣ ";
			} else if (listOfDataBuckets[i].name === "ChristmasOffer") {
				expirationText = "Από Χριστουγεννιάτικη Προσφορά διαθέσιμα έως ";
			} else if (listOfDataBuckets[i].expirationDateFormated === null) {
				expirationText = "";
			} else {
				expirationText = "Διαθέσιμα για πλοήγηση στο Ιnternet έως ";
			}

			let title =
				unlimitedSpotted === 1
					? "ΑΠΕΡΙΟΡΙΣΤΑ MB"
					: listOfDataBuckets[i].balanceFormated +
						listOfDataBuckets[i].balanceMeasureUnitFormated;

			let numberOfBars = 8;
			let minimumBarsBytesLimit = 10240;
			let numberOfActiveBars = 0;
			if (unlimitedSpotted === 1) {
				numberOfActiveBars = numberOfBars;
			} else if (listOfDataBuckets[i].balance > minimumBarsBytesLimit) {
				numberOfActiveBars = numberOfBars;
			}

			let detailLine =
				expirationText + (listOfDataBuckets[i].expirationDateFormated || "");

			output.push(
				<li
					key={listOfDataBuckets[i].name || i}
					className="remain-data">
					<h4>{title}</h4>
					<div className="bars">
						{barsSet(numberOfBars, numberOfActiveBars)}
					</div>
					<div className="clear"></div>
					<div>
						<h5>{detailLine}</h5>
						<div className="clear"></div>
					</div>
				</li>,
			);
		}
	}
	return output;
}

function infoPopUpTemplate(data) {
	//For info Pop Up
	let output = [];
	let landPageData = JSON.parse(sessionStorage.landPageData);
	let listOfDataBuckets = data.allData.listOfDataBuckets;
	let listOfUnlimitedDataPrepaidNinja =
		data.allData.listOfUnlimitedDataPrepaidNinja;
	let UserType = Functions["custom"]["getUserType"]();
	// let detailsOnly = checkForUnlimited(data);

	if (listOfDataBuckets.length > 0) {
		for (let i = 0; i < listOfDataBuckets.length; i++) {
			let unlimitedSpotted = 0;
			if (listOfUnlimitedDataPrepaidNinja.length > 0) {
				for (let j = 0; j < listOfUnlimitedDataPrepaidNinja.length; j++) {
					if (
						listOfDataBuckets[i].name ===
						listOfUnlimitedDataPrepaidNinja[j].bucket
					) {
						unlimitedSpotted = 1;
						break;
					}
				}
			}
			let expirationText = "";
			let bucketHeaderTitle = "";
			if (
				listOfDataBuckets[i].reloadDateFormated !== null &&
				(landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_BUSINESS_COST_CONTROL" ||
					landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_RESIDENTIAL_COST_CONTROL")
			) {
				if (listOfDataBuckets[i].balance === 0) {
					expirationText = "";
				} else if (listOfDataBuckets[i].expirationDateFormated !== null) {
					expirationText = "Διαθέσιμα έως ";
				} else {
					expirationText = "";
				}
			} else if (
				listOfDataBuckets[i].type === "OTT" ||
				listOfDataBuckets[i].type === "SPOTIFY_FREE"
			) {
				expirationText = "Διαθέσιμα για χρήση αποκλειστικά στην υπηρεσία ";
				if (listOfDataBuckets[i].type === "OTT") {
					expirationText += "COSMOTE TV GO";
				} else if (listOfDataBuckets[i].type === "SPOTIFY_FREE") {
					expirationText += "Spotify";
				}
			} else if (
				(listOfDataBuckets[i].type === "PERIODICBUNDLE" ||
					listOfDataBuckets[i].type === "NEWKS") &&
				landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_RESIDENTIAL_COST_CONTROL"
			) {
				expirationText = "";
			} else if (
				landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_BUSINESS_COST_CONTROL" ||
				landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_RESIDENTIAL_COST_CONTROL"
			) {
				if (listOfDataBuckets[i].name === "Permanent30") {
					expirationText =
						"Δωρεάν MB για 2 ώρες από το DATAMENOW. Τα ΜΒ του πακέτου λήγουν αυτόματα στις ";
				} else if (listOfDataBuckets[i].name === "SpecificOffers1") {
					expirationText = "AΠO TO ΠΑΚΕΤΟ 10GB ΔΩΡΕΑΝ ΓΙΑ 7 ΗΜΕΡΕΣ ΕΩΣ ";
				} else if (listOfDataBuckets[i].name === "ChristmasOffer") {
					expirationText = "Από Χριστουγεννιάτικη Προσφορά διαθέσιμα έως ";
				} else {
					expirationText = "Διαθέσιμα έως ";
				}
			} else if (
				landPageData.contractInfoCarrier.customerSegment === "PREPAID_FROG" ||
				landPageData.contractInfoCarrier.customerSegment ===
					"PREPAID_COSMOKARTA" ||
				landPageData.contractInfoCarrier.customerSegment ===
					"PREPAID_WHATSUP" ||
				landPageData.contractInfoCarrier.customerSegment === "NEO"
			) {
				if (
					listOfDataBuckets[i].type === "CAT1" ||
					listOfDataBuckets[i].type === "CAT2" ||
					listOfDataBuckets[i].type === "CAT3" ||
					listOfDataBuckets[i].type === "CAT7"
				) {
					expirationText = "Διαθέσιμα για VIDEO KAI MUSIC STREAMING έως ";
				} else if (
					listOfDataBuckets[i].type === "SOCIAL1" ||
					listOfDataBuckets[i].type === "SOCIAL2"
				) {
					expirationText = "Διαθέσιμα για SOCIAL MEDIA έως ";
				} else if (
					listOfDataBuckets[i].type === "CHAT1" ||
					listOfDataBuckets[i].type === "CHAT2"
				) {
					expirationText = "Διαθέσιμα για CHATTING έως ";
				} else if (
					listOfDataBuckets[i].type === "CAT5" ||
					listOfDataBuckets[i].type === "CAT7"
				) {
					expirationText = "Διαθέσιμα για VIDEO KAI MUSIC STREAMING έως ";
				} else if (
					listOfDataBuckets[i].type === "Social_Chat1" ||
					listOfDataBuckets[i].type === "Social_Chat3"
				) {
					expirationText = "Διαθέσιμα για SOCIAL MEDIA έως ";
				} else if (listOfDataBuckets[i].name === "Permanent30") {
					expirationText =
						"Δωρεάν MB για 2 ώρες από το DATAMENOW. Τα ΜΒ του πακέτου λήγουν αυτόματα στις ";
				} else if (listOfDataBuckets[i].name === "SpecificOffers1") {
					expirationText = "AΠO TO ΠΑΚΕΤΟ 10GB ΔΩΡΕΑΝ ΓΙΑ 7 ΗΜΕΡΕΣ ΕΩΣ ";
				} else if (listOfDataBuckets[i].name === "ChristmasOffer") {
					expirationText = "Από Χριστουγεννιάτικη Προσφορά διαθέσιμα έως ";
				} else if (listOfDataBuckets[i].expirationDateFormated === null) {
					expirationText = "";
				} else {
					expirationText = "Διαθέσιμα για πλοήγηση στο Ιnternet έως ";
				}
			}
			if (
				landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_BUSINESS_COST_CONTROL" ||
				landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_RESIDENTIAL_COST_CONTROL"
			) {
				bucketHeaderTitle = "Διαθέσιμα MB ";
				let bundleReloadName = data?.allData?.bundleReloadName
					? data?.allData?.bundleReloadName
					: data?.data?.data?.data?.bundleReloadName;
				let bundleKartoStudentName = data?.allData?.bundleKartoStudentName
					? data?.allData?.bundleKartoStudentName
					: data?.data?.data?.data?.bundleKartoStudentName;

				if (
					(landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_BUSINESS_COST_CONTROL" ||
						landPageData.contractInfoCarrier.customerSegment ===
							"HYBRID_RESIDENTIAL_COST_CONTROL") &&
					(listOfDataBuckets[i].type === "OTT" ||
						listOfDataBuckets[i].type === "SPOTIFY_FREE")
				) {
					if (listOfDataBuckets[i].type === "OTT") {
						bucketHeaderTitle = "Από πακέτο COSMOTE TV GO";
					} else {
						bucketHeaderTitle = "Από πακέτο SPOTIFY";
					}
				} else if (
					listOfDataBuckets[i].category === "CONTRACT" ||
					(landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_RESIDENTIAL_COST_CONTROL" &&
						listOfDataBuckets[i].type === "PERIODICBUNDLE")
				) {
					bucketHeaderTitle = "Από το πρόγραμμα σου ";
				} else if (listOfDataBuckets[i].category === "OFFERS") {
					if (
						landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_RESIDENTIAL_COST_CONTROL"
					) {
						if (listOfDataBuckets[i].name === "Permanent14") {
							bucketHeaderTitle = "Από προσφορά ";
						} else {
							bucketHeaderTitle = "Από προσφορές ";
						}
					} else if (
						landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_BUSINESS_COST_CONTROL"
					) {
						if (listOfDataBuckets[i].name === "Permanent14") {
							bucketHeaderTitle = "Από προσφορά ";
						} else {
							bucketHeaderTitle = "MB από προσφορές ";
						}
					}
				} else if (listOfDataBuckets[i].category === "BUNDLES") {
					if (
						landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_RESIDENTIAL_COST_CONTROL"
					) {
						bucketHeaderTitle = "Από πακέτα Internet";
					} else if (
						landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_BUSINESS_COST_CONTROL"
					) {
						bucketHeaderTitle = "ΜΒ από πακέτα Internet";
					}
				}
				let reloadDateTextualMessage = "";

				if (
					landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_RESIDENTIAL_COST_CONTROL" &&
					listOfDataBuckets[i].type === "PERIODICBUNDLE" &&
					listOfDataBuckets[i].reloadDateFormated !== null
				) {
					reloadDateTextualMessage =
						(expirationText !== "" ? "." : "") +
						"Από το πρόγραμμα σου, που θα ανανεωθούν" +
						" αυτόματα στις " +
						listOfDataBuckets[i].reloadDateFormated;
				} else if (
					landPageData.contractInfoCarrier.customerSegment ===
						"HYBRID_RESIDENTIAL_COST_CONTROL" &&
					listOfDataBuckets[i].type === "NEWKS" &&
					listOfDataBuckets[i].reloadDateFormated !== null
				) {
					reloadDateTextualMessage =
						(expirationText !== "" ? "." : "") +
						"Θα ανανεωθούν αυτόματα στις " +
						listOfDataBuckets[i].reloadDateFormated;
				} else if (listOfDataBuckets[i].reloadDateFormated !== null) {
					if (listOfDataBuckets[i].name !== "KartoStudent2") {
						if (listOfDataBuckets[i].name == "Permanet14") {
							reloadDateTextualMessage =
								(expirationText !== "" ? "." : "") +
								"Τα MB του δωρεάν πακέτου, θα" +
								" ανανεωθούν αυτόματα στις" +
								" " +
								listOfDataBuckets[i].reloadDateFormated +
								".";
						} else {
							reloadDateTextualMessage =
								(expirationText !== "" ? "." : "") +
								"Τα ΜΒ του πακέτου " +
								(bundleReloadName ? bundleReloadName : "") +
								", θα ανανεωθούν αυτόματα στις " +
								listOfDataBuckets[i].reloadDateFormated +
								".";
						}
					} else {
						reloadDateTextualMessage =
							(expirationText !== "" ? "." : "") +
							"Τα ΜΒ του πακέτου " +
							(bundleKartoStudentName ? bundleKartoStudentName : "") +
							", θα ανανεωθούν αυτόματα στις " +
							listOfDataBuckets[i].reloadDateFormated;
					}
				}
			}
			output.push(
				<div className="row">
					{bucketHeaderTitle === "" ? <></> : <h5>{bucketHeaderTitle}</h5>}
					{unlimitedSpotted === 1 ? (
						<div className="mb">ΑΠΕΡΙΟΡΙΣΤΑ MB</div>
					) : (
						<div className="mb">
							{listOfDataBuckets[i].balanceFormated}
							{listOfDataBuckets[i].balanceMeasureUnitFormated}
						</div>
					)}
					{expirationText} {listOfDataBuckets[i].expirationDateFormated}
				</div>,
			);
		}
	}
	return output;
}

function hybridLiElements(data) {
	let output = [];
	let landPageData = JSON.parse(sessionStorage.landPageData);
	let listOfDataBuckets = data.allData.listOfDataBuckets;
	let listOfUnlimitedDataPrepaidNinja =
		data.allData.listOfUnlimitedDataPrepaidNinja;

	if (listOfDataBuckets.length > 0) {
		for (let i = 0; i < listOfDataBuckets.length; i++) {
			let unlimitedSpotted = 0;
			if (listOfUnlimitedDataPrepaidNinja.length > 0) {
				for (let j = 0; j < listOfUnlimitedDataPrepaidNinja.length; j++) {
					if (
						listOfDataBuckets[i].name ===
						listOfUnlimitedDataPrepaidNinja[j].bucket
					) {
						unlimitedSpotted = 1;
						break;
					}
				}
			}

			let expirationText = "";
			if (listOfDataBuckets[i].balance === 0) {
				expirationText = "";
			} else if (listOfDataBuckets[i].expirationDateFormated !== null) {
				expirationText = "Διαθέσιμα έως ";
			}

			let bucketHeaderTitle = "";
			if (
				listOfDataBuckets[i].type === "OTT" ||
				listOfDataBuckets[i].type === "SPOTIFY_FREE"
			) {
				bucketHeaderTitle =
					listOfDataBuckets[i].type === "OTT"
						? "Από πακέτο COSMOTE TV GO"
						: "Από πακέτο SPOTIFY";
			} else if (
				listOfDataBuckets[i].category === "CONTRACT" ||
				(landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_RESIDENTIAL_COST_CONTROL" &&
					listOfDataBuckets[i].type === "PERIODICBUNDLE")
			) {
				bucketHeaderTitle = "Από το πρόγραμμα σου";
			} else if (listOfDataBuckets[i].category === "OFFERS") {
				if (listOfDataBuckets[i].name === "Permanent14") {
					bucketHeaderTitle = "Από προσφορά";
				} else if (
					landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_RESIDENTIAL_COST_CONTROL"
				) {
					bucketHeaderTitle = "Από προσφορές";
				} else {
					bucketHeaderTitle = "MB από προσφορές";
				}
			} else if (listOfDataBuckets[i].category === "BUNDLES") {
				bucketHeaderTitle =
					landPageData.contractInfoCarrier.customerSegment ===
					"HYBRID_RESIDENTIAL_COST_CONTROL"
						? "Από πακέτα Internet"
						: "ΜΒ από πακέτα Internet";
			}

			let title =
				unlimitedSpotted === 1
					? "ΑΠΕΡΙΟΡΙΣΤΑ MB"
					: listOfDataBuckets[i].balanceFormated +
						listOfDataBuckets[i].balanceMeasureUnitFormated;

			let numberOfBars = 8;
			let numberOfActiveBars = 0;
			if (unlimitedSpotted === 1 || listOfDataBuckets[i].balance > 0) {
				numberOfActiveBars = numberOfBars;
			}

			let detailLine = bucketHeaderTitle ? bucketHeaderTitle + " — " : "";
			detailLine +=
				expirationText + (listOfDataBuckets[i].expirationDateFormated || "");

			output.push(
				<li
					key={listOfDataBuckets[i].name || i}
					className="remain-data">
					<h4>{title}</h4>
					<div className="bars">
						{barsSet(numberOfBars, numberOfActiveBars)}
					</div>
					<div className="clear"></div>
					<div>
						<h5>{detailLine}</h5>
						<div className="clear"></div>
					</div>
				</li>,
			);
		}
	}
	return output;
}

function statisticsPopupMarkup(title, listItems, onClose) {
	return (
		<div
			className="lightbox"
			id="statistics"
			style={{ display: "block" }}>
			<div className="content">
				<div className="stats-icon"></div>
				<h2>{title}</h2>
				<div
					className="text scroll-content"
					style={{
						overflow: "hidden",
						padding: "0px",
						width: "auto",
					}}>
					<div
						className="jspContainer"
						style={{
							width: "auto",
							height: "370px",
							overflowY: "auto",
						}}>
						<div
							className="jspPane"
							style={{
								padding: "0px 30px 0px 0px",
								top: "0px",
								left: "0px",
								width: "auto",
							}}>
							<ul
								className="statistics-list"
								id="ilElements">
								{listItems}
							</ul>
						</div>
					</div>
				</div>
				<a
					className="cancel addCursorPointer customClassAddCursorPointer"
					onClick={onClose}>
					Κλείσιμο
				</a>
			</div>
		</div>
	);
}

const InfoPopUp = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					data: { data: [] },
					replace: {},
					mapper: Mapper,
				},
			},
			template: "plain",
			templateConfiguration: {
				cardTopTemplate: function () {
					let UserType = Functions["custom"]["getUserType"]();
					const closePopup = () => {
						window["modal"].setState({ show: false });
					};

					if (
						UserType === "POSTB" ||
						UserType === "POSTB_SPLIT" ||
						UserType === "POSTR"
					) {
						let data = this.state.data[0].data.data.data;
						return statisticsPopupMarkup(
							"Tα MB σας αναλυτικά",
							liElements(data),
							closePopup,
						);
					} else if (UserType === "PREPAID_COSMOKARTA" || UserType === "NEO") {
						let data = this.state.data[0].data.data.data;
						return statisticsPopupMarkup(
							"Tα MB σας αναλυτικά",
							cosmokartaLiElements(data),
							closePopup,
						);
					} else if (
						UserType === "HYBRID_BUSINESS_COST_CONTROL" ||
						UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
					) {
						let data = this.state.data[0].data.data.data;
						return statisticsPopupMarkup(
							UserType === "HYBRID_BUSINESS_COST_CONTROL"
								? "Τα MB σας αναλυτικά"
								: "Τα MB σου αναλυτικά",
							hybridLiElements(data),
							closePopup,
						);
					} else {
						let data = this.state.data[0].data.data.data;
						return (
							<div
								className="lightbox"
								id="statistics-prepaid"
								style={{ display: "block" }}>
								<div className="content">
									<div className="stats-icon"></div>
									<h2>Τα ΜΒ σου αναλυτικά</h2>

									<div
										className="scroll-area"
										style={{
											overflowY: "scroll",
										}}>
										{data.length !== 0 && infoPopUpTemplate(data)}
										<a
											className="cancel customClassAddCursorPointer "
											onClick={closePopup}>
											Κλείσιμο
										</a>
									</div>
								</div>
							</div>
						);
					}
				},
				includeProperties: ["none"],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default InfoPopUp;
